<script>
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import {link, location, push, pop, replace} from 'svelte-spa-router';


    onMount(async() => {

    });

</script>

<Iqtemplate>
    <div class="cszinputcontainer">
        <div class="cszinputfieldcontainer">
            <div class="progresstext">4/6</div>
            <div class="csztopcopy">
                Are you a first time homebuyer?
            </div>
            <Chipscompnent
            chipsdata={ [
                {sz: "med", s: false, t: "Yes", i:"/img/Check.svg", cbf:()=>{$user_data.skip_home_type = false; $user_data.firsttimebuyer = true;}, n: "#/qualify"},
                 {sz: "med", s: true, t: "No", i:"/img/X.svg", cbf:()=>{$user_data.skip_home_type = true; $user_data.firsttimebuyer = false;}, n: "#/current_homeowner"},
            ] }
            />

            <div class="progressbuttonholder">
                <button on:click={()=>{push("#/credit_score");}} class="backbutton"><span class="backarrowcontainer"><img src="/img/triangle-left-arrow.svg" alt="back arrow" /></span>Go Back</button>
            </div>

        </div>
    </div>

</Iqtemplate>

<style>

</style>